import { EPageSubmenuType } from '@hts/shared/enums';
import { IMappedMenu, IMappedSubmenuCategory } from '@hts/shared/types';
import { useMemo } from 'react';
import { useGetTopMenu1Categories } from './useGetTopMenu1Categories';
import { useGetTopMenus } from './useGetTopMenus';

export const useGetAllSeasonsCategories = (menus?: IMappedMenu[]): IMappedSubmenuCategory[] => {
  const { topMenu1 } = useGetTopMenus(menus);

  const allSeasonsCategories = useGetTopMenu1Categories(
    topMenu1?.submenus,
    EPageSubmenuType.ALL_SEASONS
  );

  return useMemo(() => {
    const flattened: IMappedSubmenuCategory[] = [];

    function flattenRecursively(category: IMappedSubmenuCategory) {
      flattened.push(category);

      if (category.categories && category.categories.length > 0) {
        category.categories.forEach(flattenRecursively);
      }
    }

    allSeasonsCategories.forEach(flattenRecursively);

    return flattened;
  }, [allSeasonsCategories]);
};
